import Guid from '@/app/utils/guid'
import Entity from '@/common/models/entity'
import Competence from '@/competences/entities/competence'
import Candidate from '@/evaluations/entities/candidate'
import { EvaluationStatus } from '@/evaluations/entities/evaluation-status'
import Judge from '@/evaluations/entities/judge'

export default class Evaluation extends Entity {
  public tenantId = Guid.empty()
  public title = ''
  public description = ''
  public status = EvaluationStatus.Draft
  public companyName = ''
  public moderatorId = ''
  public remarks = ''
  public applicationsCount = 0
  public dbApplicationsCount = 0
  public interviewsCount = 0
  public candidates: Candidate[] = []
  public judges: Judge[] = []
  public competences: Competence[] = []
  public referenceNumber = ''
  public moderatorEmail = ''
}
